export default function ( error ) {
    if ( error.response.status === 401 ) {
        window.auth.logout()
    }
}
